<template>
  <section class="ca-section">
    <div class="container-fluid">

      <!-- Header -->
      <div class="caf-header">
        <div class="caf-header-text">
          <span class="caf-badge">ফ্রি রিসোর্স</span>
          <h2>সাম্প্রতিক সমাচার</h2>
          <p>মাসভিত্তিক বাছাইকৃত কারেন্ট অ্যাফেয়ার্স — বাংলাদেশ, আন্তর্জাতিক, বিজ্ঞান ও ক্রীড়া — সম্পূর্ণ ফ্রি</p>
          <a class="caf-view-all" @click="goToCurrentAffairs">
            সব সংখ্যা দেখুন →
          </a>
        </div>
      </div>

      <!-- Cards -->
      <div class="caf-grid">
        <article
          v-for="issue in issues"
          :key="issue.key"
          class="caf-card"
          @click="goToIssue(issue)"
        >
          <div class="caf-card-head">
            <span class="caf-cal">📅</span>
            <div class="caf-head-text">
              <h3>{{ issue.label }}</h3>
              <span class="caf-count">{{ toBengali(issue.count) }} প্রশ্ন · {{ toBengali(issue.categories.length) }} বিষয়</span>
            </div>
          </div>
          <div class="caf-card-body">
            <div class="caf-tags">
              <span
                v-for="c in issue.categories"
                :key="c.key"
                class="caf-tag"
              >
                {{ c.name }} <b>{{ toBengali(c.items.length) }}</b>
              </span>
            </div>
            <span class="caf-link">
              বিস্তারিত পড়ুন
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                <path d="M13.267 4.209a.75.75 0 0 0-1.06 1.06l5.58 5.58H3.75a.75.75 0 0 0 0 1.5h14.037l-5.58 5.58a.75.75 0 1 0 1.06 1.06l6.868-6.867a.75.75 0 0 0 0-1.062l-6.868-6.851z" fill="currentColor"/>
              </svg>
            </span>
          </div>
        </article>

        <!-- Coming soon -->
        <article class="caf-card caf-card--soon">
          <div class="caf-card-head">
            <span class="caf-cal">🗓️</span>
            <div class="caf-head-text">
              <h3>পরবর্তী মাস</h3>
              <span class="caf-count">শীঘ্রই আসছে</span>
            </div>
          </div>
          <div class="caf-card-body">
            <p class="caf-soon-text">প্রতি মাসের সাম্প্রতিক তথ্য এখানে নিয়মিত যুক্ত হবে। চোখ রাখুন।</p>
          </div>
        </article>
      </div>

    </div>
  </section>
</template>

<script>
import { defineComponent } from "vue";
import router from "@/router";
import { URLs } from "@/static";
import { currentAffairsIssues } from "@/components/WelcomePages/currentAffairsData";

export default defineComponent({
  setup() {
    const issues = currentAffairsIssues.filter((i) => i.published);

    const toBengali = (n) => {
      const bn = ["০", "১", "২", "৩", "৪", "৫", "৬", "৭", "৮", "৯"];
      return String(n).split("").map((c) => bn[parseInt(c)] ?? c).join("");
    };

    const goToIssue = (issue) => router.push({ name: issue.routeName });
    const goToCurrentAffairs = () => router.push({ name: URLs.ROUTE_CURRENT_AFFAIRS_NAME });

    return { issues, toBengali, goToIssue, goToCurrentAffairs };
  },
});
</script>

<style scoped>
/* Section */
.ca-section {
  background: #12142e;
  padding: 80px 0 64px;
  margin-top: 48px;
  border-top: 4px solid #0095FF;
}

/* Header */
.caf-header { text-align: center; margin-bottom: 40px; }
.caf-badge {
  display: inline-block; font-size: 0.7rem; font-weight: 700;
  letter-spacing: 0.07em; text-transform: uppercase;
  color: #7CC6FF; background: rgba(0,149,255,0.15);
  border: 1px solid rgba(0,149,255,0.32);
  padding: 3px 12px; border-radius: 999px; margin-bottom: 14px;
}
.caf-header-text h2 { font-size: 1.8rem; font-weight: 800; color: #fff; margin: 0 0 8px 0; }
.caf-header-text p { font-size: 0.9rem; color: #94a3b8; margin: 0 0 20px 0; }
.caf-view-all {
  display: inline-flex; align-items: center;
  font-size: 0.85rem; font-weight: 700; color: #38B6FF;
  cursor: pointer; white-space: nowrap;
  border-bottom: 1px solid rgba(0,149,255,0.4);
  padding-bottom: 2px; transition: color 0.18s;
}
.caf-view-all:hover { color: #7CC6FF; }

/* Grid — capped so few cards don't stretch oddly */
.caf-grid {
  display: grid; grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: 20px; max-width: 760px; margin: 0 auto;
}
@media (max-width: 700px) { .caf-grid { grid-template-columns: 1fr; max-width: 420px; } }

/* Card */
.caf-card {
  background: #1e2048; border: 1px solid rgba(255,255,255,0.08);
  border-radius: 16px; overflow: hidden; cursor: pointer;
  transition: transform 0.2s, box-shadow 0.2s, border-color 0.2s;
  display: flex; flex-direction: column;
}
.caf-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 12px 32px rgba(0,0,0,0.4);
  border-color: rgba(0,149,255,0.45);
}

/* Head */
.caf-card-head {
  display: flex; align-items: center; gap: 13px;
  padding: 18px 18px 14px;
  border-bottom: 1px solid rgba(255,255,255,0.06);
}
.caf-cal { font-size: 1.7rem; line-height: 1; flex: none; }
.caf-head-text h3 { font-size: 1.1rem; font-weight: 800; color: #fff; margin: 0 0 2px; text-align: left; }
.caf-count { font-size: 0.78rem; font-weight: 600; color: #38B6FF; }

/* Body */
.caf-card-body { padding: 16px 18px 18px; flex: 1; display: flex; flex-direction: column; }
.caf-tags { display: flex; flex-wrap: wrap; gap: 6px; margin-bottom: 16px; flex: 1; align-content: flex-start; }
.caf-tag {
  font-size: 0.7rem; font-weight: 600; color: #bfe3ff;
  background: rgba(0,149,255,0.14); border: 1px solid rgba(0,149,255,0.28);
  padding: 3px 9px; border-radius: 6px;
}
.caf-tag b { font-weight: 800; color: #eaf4ff; }
.caf-link {
  display: inline-flex; align-items: center; gap: 5px;
  font-size: 0.8rem; font-weight: 700; color: #38B6FF; margin-top: auto;
}

/* Coming soon */
.caf-card--soon { cursor: default; opacity: 0.72; border-style: dashed; }
.caf-card--soon:hover { transform: none; box-shadow: none; border-color: rgba(255,255,255,0.14); }
.caf-card--soon .caf-count { color: #94a3b8; }
.caf-soon-text { font-size: 0.82rem; color: #94a3b8; line-height: 1.6; margin: 0; text-align: left; }
</style>
